import axios from "axios";

export const userCart = async (cart, ShippingDistance, expressShipping, authtoken) =>
  await axios.post(
    `${process.env.REACT_APP_API}/user/cart`,
    { cart, ShippingDistance, expressShipping },
    {
      headers: {
        authtoken,
      },
    }
  );

export const getUsers = async (sort, order, page, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/admin/users`, {
    sort,
    order,
    page,
  }, {
    headers: {
      authtoken,
    },
  });

  export const updateUserPosition = async (authtoken, email, positionId) => {
    return await axios.post(
      `${process.env.REACT_APP_API}/user/position`,
      { email, positionId },
      {
        headers: {
          authtoken,
        },
      }
    );
  };

  export const saveUserCompany = async (authtoken, email, companyId) =>
    await axios.post(`${process.env.REACT_APP_API}/user/company`, {
      email,
      companyId,
    }, {
      headers: {
        authtoken,
      },
    });

export const searchUserNumber = async (arg, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/admin/find-user/number`, { arg }, {
    headers: {
      authtoken,
    },
  });

export const fetchUsersByFilter = async (arg, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/search/user/filter`, arg, {
    headers: {
      authtoken,
    },
  });

export const getTransactions = async (authtoken) =>
  await axios.get(`${process.env.REACT_APP_API}/admin/transactions`, {
    headers: {
      authtoken,
    },
  });

export const getCarts = async (authtoken) =>
  await axios.get(`${process.env.REACT_APP_API}/admin/carts`, {
    headers: {
      authtoken,
    },
  });

export const getUserCart = async (authtoken) =>
  await axios.get(`${process.env.REACT_APP_API}/user/cart`, {
    headers: {
      authtoken,
    },
  });

export const deleteAbondenedCart = async (id, authtoken) => {
  await axios.post(`${process.env.REACT_APP_API}/admin/delete-cart`, { id }, {
    headers: {
      authtoken
    },
  })
}



export const EmailAllCartUsers = async () =>
  await axios.post(`${process.env.REACT_APP_API}/user/email`);

export const EmailAllRewardUsers = async () =>
  await axios.post(`${process.env.REACT_APP_API}/user/email-rewards`);



export const applyPoints = async (authtoken, point) =>
  await axios.post(
    `${process.env.REACT_APP_API}/user/cart/point`,
    { point },
    {
      headers: {
        authtoken,
      },
    }
  );


export const applyPoint = async (authtoken, point) =>
  await axios.post(
    `${process.env.REACT_APP_API}/user/cart/point`,
    { point },
    {
      headers: {
        authtoken,
      },
    }
  );


export const getCartCount = async () =>
  await axios.get(`${process.env.REACT_APP_API}/carts/total`);

export const getUserCount = async () =>
  await axios.get(`${process.env.REACT_APP_API}/users/total`);

export const emptyUserCart = async (authtoken) =>
  await axios.delete(`${process.env.REACT_APP_API}/user/cart`, {
    headers: {
      authtoken,
    },
  });

export const removeUserPaymentIntent = async (authtoken) => {
  await axios.post(`${process.env.REACT_APP_API}/user/remove-payment-intent`,
    {},
    {
      headers: {
        authtoken,
      },
    }
  );
}



export const saveUserAddress = async (authtoken, address) =>
  await axios.post(
    `${process.env.REACT_APP_API}/user/address`,
    { address },
    {
      headers: {
        authtoken,
      },
    }
  );

export const saveUserName = async (authtoken, values) =>
  await axios.post(
    `${process.env.REACT_APP_API}/user/name`,
    { values },
    {
      headers: {
        authtoken,
      },
    }
  )

export const savePoints = async (authtoken, Points, _id) =>
  await axios.post(
    `${process.env.REACT_APP_API}/user/points/${_id}`,
    { Points, _id },
    {
      headers: {
        authtoken,
      },
    }
  )


export const changePoints = async (userId, authtoken) =>
  await axios.put(
    `${process.env.REACT_APP_API}/admin/points-id`,
    { userId },
    {
      headers: {
        authtoken,
      },
    }
  );

export const saveUserLastName = async (authtoken, lastName) =>
  await axios.post(
    `${process.env.REACT_APP_API}/user/last-name`,
    { lastName },
    {
      headers: {
        authtoken,
      },
    }
  )

export const saveUserUnitAddress = async (authtoken, unitAddress) =>
  await axios.post(
    `${process.env.REACT_APP_API}/user/unit-address`,
    { unitAddress },
    {
      headers: {
        authtoken,
      },
    }
  )

export const saveUserCityRestriction = async (restriction, _id) =>
  await axios.post(
    `${process.env.REACT_APP_API}/user/city-address/restriction`,
    { restriction, _id },

  )

export const saveUserStateAddress = async (authtoken, StateAddress) =>
  await axios.post(
    `${process.env.REACT_APP_API}/user/state-address`,
    { StateAddress },
    {
      headers: {
        authtoken,
      },
    }
  )

export const saveUserZipAddress = async (authtoken, ZipAddress) =>
  await axios.post(
    `${process.env.REACT_APP_API}/user/zip-address`,
    { ZipAddress },
    {
      headers: {
        authtoken,
      },
    }
  )

export const saveUserPhoneNumber = async (authtoken, PhoneNumber) =>
  await axios.post(
    `${process.env.REACT_APP_API}/user/phone-number`,
    { PhoneNumber },
    {
      headers: {
        authtoken,
      },
    }
  )

export const saveUserAccess = async (authtoken, userId, access, store) =>
  await axios.post(
    `${process.env.REACT_APP_API}/user/access-level`,
    { userId, access, store },
    {
      headers: {
        authtoken,
      },
    }
  )

export const revokeUserAccess = async (authtoken, userId) =>
  await axios.post(
    `${process.env.REACT_APP_API}/user/revoke-access`,
    { userId },
    {
      headers: {
        authtoken,
      },
    }
  )



export const applyCoupon = async (authtoken, coupon) =>
  await axios.post(
    `${process.env.REACT_APP_API}/user/cart/coupon`,
    { coupon },
    {
      headers: {
        authtoken,
      },
    }
  );

export const applyOnlineDiscount = async (authtoken) =>
  await axios.post(
    `${process.env.REACT_APP_API}/user/cart/onlineDiscount`,
    {
      headers: {
        authtoken,
      },
    }
  );

export const createOrder = async (stripeResponse, authtoken, point, checked, time, date, coupon1, shipping, deliveryType, pickupStore, dispatchStore, storeNumber, expressShipping, specialId, shippingPrice, packing) =>
  await axios.post(
    `${process.env.REACT_APP_API}/user/order`,
    { stripeResponse, point, checked, time, date, coupon1, shipping, deliveryType, pickupStore, dispatchStore, storeNumber, expressShipping, specialId, shippingPrice, packing },
    {
      headers: {
        authtoken,
      },
    }
  );

export const getUserOrders = async (authtoken) =>
  await axios.get(`${process.env.REACT_APP_API}/user/orders`, {
    headers: {
      authtoken,
    },
  });

export const getUserTransaction = async (authtoken) =>
  await axios.get(`${process.env.REACT_APP_API}/user/user-transaction`, {
    headers: {
      authtoken,
    },
  });



export const getUserOrdersCount = async (authtoken) =>
  await axios.get(`${process.env.REACT_APP_API}/user/order-count`, {
    headers: {
      authtoken,
    },
  });

export const getDiffUsersOrdersCount = async (_id, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/user/order-count-user`,
    { _id }, {
    headers: {
      authtoken,
    },
  }
  );



export const getWishlist = async (authtoken) =>
  await axios.get(`${process.env.REACT_APP_API}/user/wishlist`, {
    headers: {
      authtoken,
    },
  });

export const removeWishlist = async (productId, authtoken) =>
  await axios.put(
    `${process.env.REACT_APP_API}/user/wishlist/${productId}`,
    {},
    {
      headers: {
        authtoken,
      },
    }
  );

export const addToWishlist = async (productId, authtoken) =>
  await axios.post(
    `${process.env.REACT_APP_API}/user/wishlist`,
    { productId },
    {
      headers: {
        authtoken,
      },
    }
  );

export const getUserDetails = async (_id, authtoken) =>
  await axios.get(`${process.env.REACT_APP_API}/admin/user/${_id}`, {
  });

export const createCashOrderForUser = async (
  authtoken,
  COD,
  couponTrueOrFalse,
  point,
  checked,
  time,
  date,
  coupon,
  shipping,
  deliveryType,
  pickupStore,
  dispatchStore,
  storeNumber,
  expressShipping,
  specialId,
  shippingPrice,
  packing
) =>
  await axios.post(
    `${process.env.REACT_APP_API}/user/cash-order`,
    { couponApplied: couponTrueOrFalse, COD, point, checked, time, date, coupon, shipping, deliveryType, pickupStore, dispatchStore, storeNumber, expressShipping, specialId, shippingPrice, packing },
    {
      headers: {
        authtoken,
      },

    }
  );

export const saveDistance = async (_id, ShippingDistance) => {
  await axios.post(
    `${process.env.REACT_APP_API}/cart/shipping`,
    { _id, ShippingDistance }

  )
}
